import { useEffect, useState } from "react";
import { Send, Bot } from "lucide-react";
import ChannelSettings from "@/components/ChannelSettings";
import SubscribersPanel from "@/components/SubscribersPanel";
import AutomationPanel from "@/components/AutomationPanel";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";

export default function TelegramPanel() {
  const [stats, setStats] = useState(null);
  const [text, setText] = useState("⚽ <b>Nuova giornata di Serie A!</b>\nUsa /pronostici per ricevere i pronostici AI 🎯");
  const [target, setTarget] = useState("subscribers");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    http.get("/stats").then((r) => setStats(r.data));
  }, []);

  const broadcast = async () => {
    setBusy(true);
    try {
      const r = await http.post("/telegram/broadcast", { text, target });
      toast.success(`Messaggio inviato (${r.data.sent} ok, ${r.data.failed} falliti${r.data.channel ? " · pubblicato anche sul canale" : ""})`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-6">
      <div className="space-y-6">
        <div className="panel p-6">
          <div className="flex items-center gap-3">
            <Bot className="text-[var(--tg)]" />
            <div>
              <div className="font-semibold">@{stats?.bot_username || "…"}</div>
              <div data-testid="bot-running-status" className={`text-xs font-mono ${stats?.bot_running ? "text-[var(--win)]" : "text-[var(--loss)]"}`}>{stats?.bot_running ? "● IN ASCOLTO (polling)" : "● OFFLINE"}</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 mt-4">Comandi: /start, /partite, /pronostici, /schedina, /classifica, /stop</p>
        </div>

        <ChannelSettings />

        <AutomationPanel />
        <SubscribersPanel />
      </div>

      <div className="panel p-6 space-y-4">
        <h3 className="font-display text-2xl font-bold uppercase">Broadcast</h3>
        <p className="text-sm text-slate-400">Supporta formattazione HTML di Telegram: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;a href&gt;.</p>
        <textarea data-testid="broadcast-text-input" value={text} onChange={(e) => setText(e.target.value)} rows={7} className="w-full bg-slate-950 border border-slate-800 rounded-md px-3 py-2 font-mono text-sm focus:outline-none focus:border-[var(--gold)]" />
        <div className="flex gap-2">
          {[["subscribers", "Iscritti (+ canale)"], ["channel", "Solo canale"]].map(([v, l]) => (
            <button key={v} data-testid={`broadcast-target-${v}`} onClick={() => setTarget(v)} className={`btn ${target === v ? "btn-gold" : "btn-ghost"}`}>{l}</button>
          ))}
        </div>
        <div className="rounded-lg bg-[#17212b] p-4 border border-slate-800">
          <div className="text-xs text-slate-500 mb-2 font-mono">ANTEPRIMA</div>
          <div className="bg-[#2b5278] rounded-xl rounded-bl-none p-3 text-sm whitespace-pre-wrap max-w-md" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <button data-testid="broadcast-send-btn" disabled={busy || !text.trim()} onClick={broadcast} className="btn btn-tg"><Send size={16} /> {busy ? "Invio..." : "Invia messaggio"}</button>
      </div>
    </div>
  );
}
